import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  processing: false,
  searchQuery: '',
  operators: [],
  error: '',
  page: 1,
  hasPrev: false,
  hasNext: false,
  totalPages: 0,
  totalResult: 0,
}

const fulfillmentOperatorSlice = createSlice({
  name: 'fulfillmentOperatorSlice',
  initialState,
  reducers: {
    getFulfillmentOperators: (state, action) => {},
    createFulfillmentOperator: (state, action) => {},
    updateFulfillmentOperatorStatus: (state, action) => {},
    setLoading: (state) => {
      state.loading = true
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setProcessing: (state, action) => {
      state.processing = action.payload ?? true
    },
    setFulfillmentOperators: (state, action) => {
      if (action.payload && Array.isArray(action.payload)) {
        state.operators = action.payload
        state.totalPages = 1
        state.page = 1
        state.hasPrev = false
        state.hasNext = false
      } else {
        const { data, page, total_pages, total_results, has_next, has_prev } =
          action.payload || {}
        state.operators = data || []
        state.page = page || 1
        state.totalPages = total_pages || 0
        state.totalResult = total_results || 0
        state.hasPrev = has_prev || false
        state.hasNext = has_next || false
      }
      state.loading = false
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload
    },
  },
})

export const {
  getFulfillmentOperators,
  createFulfillmentOperator,
  updateFulfillmentOperatorStatus,
  setLoading,
  setError,
  setProcessing,
  setFulfillmentOperators,
  setSearchQuery,
} = fulfillmentOperatorSlice.actions

export default fulfillmentOperatorSlice.reducer
